module.exports = __webpack_public_path__ + "components/MapControl/svg/Pomnik_mogiła.svg?4c3255fa";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Pomnik_mogiła.svg
// module id = 1977
// module chunks = 0